import React from "react";

const UserNameInput = ({ theme, userName, handleChange, disabled }) => {
  return (
    <input
      type="text"
      name="userName"
      value={userName}
      onChange={handleChange}
      disabled={disabled} // Add disabled prop here
      style={{
        width: "100%",
        backgroundColor: disabled ? theme.colors.mediumPurple : "#868A9C", // Change background color when disabled
        color: disabled ? "white" : "white", // Optional: Change text color when disabled
        padding: "10px",
        border: "none",
        borderRadius: "4px",
        fontFamily: "basic-sans",
      }}
    />
  );
};

export default UserNameInput;
